import { render, staticRenderFns } from "./ProductivityContentV3.vue?vue&type=template&id=245008aa&"
import script from "./ProductivityContentV3.vue?vue&type=script&lang=js&"
export * from "./ProductivityContentV3.vue?vue&type=script&lang=js&"
import style0 from "./ProductivityContentV3.vue?vue&type=style&index=0&id=245008aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports